/*
 * 站外链接里**会变**的那一条：研究笔记（博客）。
 *
 * 背景：2026-09-10 用户要求首屏留研究笔记的位置，「这个博客地址你可以先留空啊，
 *   但是你要留」。我先做成了「地址为空就显示一行灰字说还在整理」，被驳回：
 *   「研究笔记应该是个链接……你不应该那样子一行文字。你可以是链接到 about blank，
 *   但是你不要这样写。」
 * 设计意图：那个位置**永远是一个链接**，长相和文案都不随地址变。地址还没有的时候
 *   链到 `about:blank`——页面的排版、字号、颜色、悬停行为全部是最终形态，
 *   发布当天只有 href 变。上一版的做法等于让一句临时文案参与排版，
 *   而临时文案是要撤的，撤的时候整段节奏又得重新量一遍。
 * 关键约束：
    10| *   1. 只在这里写一次，别在组件里再兜一次底。
 *   2. 填完整地址（`https://lab.miyang.cn/…`），不是站内相对路径：
 *      这个包挂在 `/ripple/` 下，相对路径会被解成 `/ripple/xxx`，指不到笔记那边。
 */
export const BLOG_URL =
  'https://lab.miyang.cn/mirage-restoring-images-degraded-by-iterative-ai-editing'

/** 首屏那一行实际用的 href。地址还没有时是个不指向任何地方的空白页。 */
export const BLOG_HREF = BLOG_URL || 'about:blank'
